export const useMergedRefs = <T>(...refs: Array<React.Ref<T> | undefined>) => {
  return (element: T | null) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') ref(element);
      else if (ref && typeof ref === 'object' && 'current' in ref)
        (ref as React.MutableRefObject<T | null>).current = element;
    });
  };
};
